module.exports = __webpack_public_path__ + "img/guanhuai.4008dcd7.png";